module.exports = __webpack_public_path__ + "img/active_dot.6f3d0b2a.svg";